<ion-content  [style.border-color]="( 'zeleni-kras' == real?.slug )?'#bc313c':'#0100ee'" style="border-top:4px solid #0100ee;" min="0" max="2400" color="white" class="ion-padding profile">


  <ion-button fill="clear" style="margin-right:0px;" class="ion-float-right" (click)="onCancel()">
    <ion-icon name="close" mode="md"></ion-icon>
  </ion-button>

  
  <div class="ion-padding profile__picture" *ngIf="event?.service?.avatarHref">
    <img *ngIf="event?.service?.avatarHref" [src]="event?.service?.avatarHref | ppImage">
  </div>

  <div  class="ion-padding profile__info" style="padding-bottom:0px; ">

    <!--h2 *ngIf="service.descriptionButtonText"><ion-icon style="color:black;" name="calendar-outline"></ion-icon> {{ service.descriptionButtonText | ppTranslate:service.descriptionButtonTextTranslations:translateService.currentLang }}</h2-->
    <div style="display: table; margin-top:5px;">
    <div style="display: table-row">
        <!--div style="width: 50px; display: table-cell; vertical-align: middle;"> <ion-img [src]="( 'zeleni-kras' == real?.slug )?'/assets/icons/event-koline.svg':'/assets/icons/event.svg'"></ion-img> </div-->
        <div style="padding-left:0px">
          <p [style.color]="( 'zeleni-kras' == real?.slug )?'#bc313c':'#0100ee'" style="font-size:small !important; color: #0100ee; font-weight: bold; line-height: 0.8 !important; color: #0100ee;">{{ event.start | date:'mediumDate': undefined: translateService?.currentLang }} ob {{ event.start | date:'H:mm' : undefined: translateService?.currentLang }}</p>
          <p *ngIf="!event.zajla" style="font-size:small !important; line-height: 0.8 !important;">{{event.location.address}}</p>
          <p *ngIf="event.zajla" style="font-size:small !important; line-height: 0.8 !important;">RTC Krvavec, Grad 76, 4207 Cerklje na Gorenjskem</p>

        </div>
    </div>
    </div>

    <h1 style="margin-top:15px;">{{ event.name }}</h1><img style="margin-top:10px; height:15px" *ngIf="event?.service?.difficulty" [src]="'/assets/icons/' + event?.service?.difficulty + '.gif'" />

    <!--h2>{{ service.shortDescription | ppTranslate:service.longDescriptionTranslations:translateService.currentLang }}</h2-->
    <p *ngIf="false && event.service?.longDescription" class="" innerHtml="{{ event.service?.longDescription }}"></p>
    <p *ngIf="event.spots >= 1">Zaradi prenove rezervacijskega sistema nam za prijavo prosim pišite na elektronski naslov:<br/><br/><a href="mailto:barbershopbunker22@gmail.com"><b>barbershopbunker22@gmail.com</b></a><br><br/>Hvala in lep kulinarični pozdrav!</p>
    <p *ngIf="event.spots < 1">Termin je že razprodan. Prosimo prijavite se na drug termin. <br/><br/><a href="mailto:barbershopbunker22@gmail.com"><b>barbershopbunker22@gmail.com</b></a><br><br/>Hvala in lep kulinarični pozdrav!</p>

  </div>

  <div class="ion-float-left clickable" style="margin-top:36px;">
    <a (click)="onCancel()"  class="pp-link">{{ 'EMPLOYEE_MODAL.CLOSE' | translate }}</a>
  </div>

  

</ion-content>